<template>
  <div class="px-4 py-4 mb-14">
    <div class="text-center">
      <!-- Success Icon with Animation -->
      <div
        class="mx-auto w-16 h-16 rounded-2xl flex items-center justify-center mb-4 animate-gentle-scale"
        :style="getSuccessIconOuterStyle()"
      >
        <div
          class="w-12 h-12 rounded-xl flex items-center justify-center"
          :style="getSuccessIconInnerStyle()"
        >
          <FlFilledCheckmarkStarburst class="h-6 w-6 text-neutral-500" />
        </div>
      </div>

      <h2 class="text-sm font-semibold text-neutral-800 mb-1">
        Meeting geplant!
      </h2>
      <p class="text-neutral-400 text-xs mb-6 max-w-sm mx-auto leading-relaxed">
        Du erhältst in Kürze eine Bestätigungs-E-Mail mit allen Kalenderdetails
        und Informationen zum Gespräch.
      </p>

      <!-- Meeting Summary Card -->
      <div 
        class="summary-card"
        :style="{
          backgroundColor: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '0.5rem',
          padding: '0.75rem',
          textAlign: 'left',
          marginBottom: '1rem'
        }"
      >
        <h3 class="text-xs font-semibold text-neutral-600 mb-3 text-center">
          Meeting-Zusammenfassung
        </h3>

        <div class="space-y-2 text-xs">
          <div class="flex justify-between items-center">
            <span class="text-neutral-500 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              Datum
            </span>
            <span class="font-medium text-neutral-800">{{
              formatDate(formData.date)
            }}</span>
          </div>

          <div class="flex justify-between items-center">
            <span class="text-neutral-500 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Uhrzeit
            </span>
            <span class="font-medium text-neutral-800">{{
              formData.time
            }}</span>
          </div>

          <div class="flex justify-between items-center">
            <span class="text-neutral-500 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
              Dauer
            </span>
            <span class="font-medium text-neutral-800"
              >{{ formData.duration }} Minuten</span
            >
          </div>

          <div
            class="pt-2 mt-3"
            :style="{
              borderTop: '1px solid #e5e7eb'
            }"
          >
            <div class="flex justify-between items-center">
              <span class="text-neutral-500 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
                Kontakt
              </span>
              <span class="font-medium text-neutral-800">{{
                formData.name
              }}</span>
            </div>

            <div
              v-if="formData.company"
              class="flex justify-between items-center mt-2"
            >
              <span class="text-neutral-500 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
                Unternehmen
              </span>
              <span class="font-medium text-neutral-800">{{
                formData.company
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Schedule Another Button -->
      <button
        @click="resetForm"
        class="cursor-pointer w-full py-2.5 px-4 text-xs font-medium rounded-md bg-black text-white transition-all duration-200"
        :style="{
          border: '1px solid black'
        }"
        @mouseover="handleButtonHover"
        @mouseout="handleButtonMouseOut"
      >
        Neues Meeting buchen
      </button>
    </div>
  </div>
</template>

<script>
import { FlFilledCheckmarkStarburst } from "@kalimahapps/vue-icons";
export default {
  components: {
    FlFilledCheckmarkStarburst,
  },

  name: "MeetingStep4",
  props: {
    formData: {
      type: Object,
      required: true,
    },
    styles: {
      type: Object,
      default: () => ({
        bubbleColor: "#3b82f6",
        textColor: "#ffffff",
      }),
    },
  },
  mounted() {
    console.log("MeetingStep4 mounted - Meeting completed!");
    console.log("Final meeting data:", this.formData);
    console.log("MeetingStep4 mounted with styles:", this.styles);
  },
  methods: {
    // Handle button hover for Shadow DOM
    handleButtonHover(event) {
      event.target.style.backgroundColor = '#171717'; // hover:bg-neutral-900
      event.target.style.color = '#e5e5e5'; // hover:text-neutral-200
    },
    
    handleButtonMouseOut(event) {
      event.target.style.backgroundColor = 'black';
      event.target.style.color = 'white';
    },

    resetForm() {
      console.log("Reset form clicked - starting new meeting flow");
      this.$emit("reset-form");
    },

    formatDate(dateString) {
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString("de-DE", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      } catch (error) {
        return dateString;
      }
    },

    // Get styling for success icon outer circle
    getSuccessIconOuterStyle() {
      const bubbleColor = this.styles.bubbleColor || "#10b981";
      return {
        backgroundColor: this.hexToRgba(bubbleColor, 0.1),
      };
    },

    // Get styling for success icon inner circle
    getSuccessIconInnerStyle() {
      const bubbleColor = this.styles.bubbleColor || "#10b981";
      return {
        backgroundColor: this.hexToRgba(bubbleColor, 0.2),
      };
    },

    // Get styling for info section background
    getInfoSectionStyle() {
      const bubbleColor = this.styles.bubbleColor || "#3b82f6";
      return {
        backgroundColor: this.hexToRgba(bubbleColor, 0.1),
      };
    },

    // Get styling for info section title
    getInfoTitleStyle() {
      const bubbleColor = this.styles.bubbleColor || "#3b82f6";
      return {
        color: this.darkenColor(bubbleColor, 0.3),
      };
    },

    // Get styling for info section text
    getInfoTextStyle() {
      const bubbleColor = this.styles.bubbleColor || "#3b82f6";
      return {
        color: this.darkenColor(bubbleColor, 0.2),
      };
    },

    // Get styling for bullet points
    getBulletStyle() {
      const bubbleColor = this.styles.bubbleColor || "#3b82f6";
      return {
        backgroundColor: this.hexToRgba(bubbleColor, 0.6),
      };
    },

    // Helper function to convert hex to rgba
    hexToRgba(hex, alpha) {
      // Remove # if present
      hex = hex.replace("#", "");

      // Parse hex values
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },

    // Helper function to darken a color
    darkenColor(hex, amount) {
      // Remove # if present
      hex = hex.replace("#", "");

      // Parse hex values
      const r = Math.max(
        0,
        parseInt(hex.substring(0, 2), 16) - Math.round(255 * amount)
      );
      const g = Math.max(
        0,
        parseInt(hex.substring(2, 4), 16) - Math.round(255 * amount)
      );
      const b = Math.max(
        0,
        parseInt(hex.substring(4, 6), 16) - Math.round(255 * amount)
      );

      // Convert back to hex
      const toHex = (n) => n.toString(16).padStart(2, "0");
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    },
  },
};
</script>

<style scoped>
@keyframes gentle-scale {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.animate-gentle-scale {
  animation: gentle-scale 2s ease-in-out infinite;
}

.info-section {
  border-radius: 0.5rem;
  padding: 0.75rem;
  margin-bottom: 1rem;
  text-align: left;
}
</style>